export interface IntakeNotifications {
  sendToClient: boolean;
  sendToAdvisor: boolean;
  sendToSupport: boolean;
}

export interface PresentationReadyNotifications {
  sendToClient: boolean;
  sendToAdvisor: boolean;
}

export interface EmailConfig {
  intake: IntakeNotifications;
  presentationReady: PresentationReadyNotifications;
  customerEmailTemplate?: 'default' | 'thankYou' | 'custom';
  advisorEmailTemplate?: 'standard' | 'enhanced' | 'custom';
  customTemplateData?: Record<string, any>;
  notificationEmail?: string;
}

export interface UsefulLink {
  title: string;
  url: string;
  description?: string;
  icon?: 'calendar' | 'article' | 'media' | 'external';
}

export interface AdvisorFeatures {
  emailConfig: EmailConfig;
  apiConfig?: {
    useCustomUrl: boolean;
    customUrl?: string;
    additionalPayloadFields?: Record<string, any>;
  };
  branding?: {
    showAdvisorInfo: boolean;
    customWelcomeMessage?: string;
    customThankYouMessage?: string;
    automationWelcomeMessage?: string;
    calendlyUrl?: string;
    usefulLinks?: UsefulLink[];
    showPoweredByPlanScout?: boolean;
  };
}

export type OutputType = 'full' | 'wor' | 'one-pager' | 'web';
export type IntakeVersion = 'full' | 'basic' | 'demo' | 'basic-healthspan';

export interface AdvisorInfo {
  customerId: string;
  name: string;
  company: string;
  email: string;
  phone: string;
  advisorPhotoUrl: string;
  companyLogoUrl: string;
  automationEnabled?: boolean;
  outputs?: OutputType[];
  intakeVersion?: IntakeVersion;
  features?: AdvisorFeatures;
  azureAdEmails?: string[];
  apiUrl?: string;
  additionalPayloadFields?: Record<string, any>;
}

/**
 * Default features for when no advisor config is found.
 * Used when no customerId is in the URL or when the DB returns no match.
 */
export const DEFAULT_ADVISOR_FEATURES: AdvisorFeatures = {
  emailConfig: {
    intake: {
      sendToClient: false,
      sendToAdvisor: false,
      sendToSupport: true
    },
    presentationReady: {
      sendToClient: false,
      sendToAdvisor: false
    },
    customerEmailTemplate: 'default'
  },
  branding: {
    showAdvisorInfo: false
  }
};

/** Default customer ID used for attribution when no ID is in the URL */
export const DEFAULT_CUSTOMER_ID = 741;
